import { all, spawn } from "redux-saga/effects";
import { combineReducers as combine } from "redux";
import { dimentions } from "reducers/redux/dimentions";
import { data } from "reducers/redux/data";
import { payment } from "reducers/redux/payment";
import { willAutoBackup } from "reducers/redux/willAutoBackup";
import { gallerysSaga as gallerys } from "reducers/saga/gallerys";
import { artistsSaga as artists } from "reducers/saga/artists";
import { tempSaga as temp } from "reducers/saga/temp";
import { orderSaga as order } from "reducers/saga/order";
import * as artistsSaga from "store/artists";
import * as gallerysSaga from "store/gallerys";
import * as tempSaga from "store/temp";
import * as orderSaga from "store/order";

export function* rootSaga() {
   yield all([
      ...Object.keys(artistsSaga).map((k: string) => spawn(artistsSaga[k as keyof typeof artistsSaga])),
      ...Object.keys(gallerysSaga).map((k: string) => spawn(gallerysSaga[k as keyof typeof gallerysSaga])),
      ...Object.keys(tempSaga).map((k: string) => spawn(tempSaga[k as keyof typeof tempSaga])),
      ...Object.keys(orderSaga).map((k: string) => spawn(orderSaga[k as keyof typeof orderSaga])),
   ]);
}

export const reducers = {
   dimentions,
   gallerys,
   artists,
   data,
   payment,
   temp,
   order,
   willAutoBackup,
};

export const combineReducers = combine(reducers);
